module.exports = __webpack_public_path__ + "static/media/bg.c0f416b4.png";